const initialState = {
    topBanners: [],
    showNav: true,
    isScrolledDown: false,
    showProfileMenu: false,
    showShoppingCart: false,
    showSearchHistory: false,
    searchTxt: '',
    searchResultWithCats: [],
    searchResultWithoutCats: [],
    prevSearchHistory: !!localStorage.getItem('prevSearchHistory') ? JSON.parse(localStorage.getItem('prevSearchHistory')) : [],
    topSearchKeywords: [],
};
const headerDesktop = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_HEADER_DESKTOP':
            return {...state, [action.name]: action.value};
        case 'CHANGE_PREV_SEARCH_HISTORY':
            localStorage.setItem('prevSearchHistory', JSON.stringify(action.limitedHistory));
            return {...state, prevSearchHistory: action.limitedHistory};
        case 'REMOVE_PREV_SEARCH_HISTORY':
            localStorage.removeItem('searchHistory');
            return {...initialState, prevSearchHistory: []};
        default:
            return state;
    }
};

export default headerDesktop;
